import React from 'react';
import { Camera } from 'lucide-react';
import { hapticLight } from '../../utils/haptics';

interface FloatingActionButtonProps {
  icon?: React.ReactNode;
  badge?: number;
  onClick: () => void;
  className?: string;
  'aria-label'?: string;
}

export function FloatingActionButton({
  icon,
  badge,
  onClick,
  className = '',
  'aria-label': ariaLabel = 'Åtgärder',
}: FloatingActionButtonProps) {
  return (
    <div
      className={`fixed right-4 z-20 lg:bottom-6 ${className}`}
      style={{ bottom: 'calc(49px + env(safe-area-inset-bottom, 0px) + 16px)' }}
    >
      <button
        onClick={() => {
          hapticLight();
          onClick();
        }}
        className="relative w-14 h-14 rounded-full shadow-ios-elevated flex items-center justify-center bg-accent-600 active:bg-accent-700 active:scale-95 transition-all animate-fab-appear"
        aria-label={ariaLabel}
      >
        {icon || <Camera size={22} className="text-white" />}
        {badge != null && badge > 0 && (
          <span className="absolute -top-1 -right-1 bg-amber-500 text-white text-[12px] font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-sm">
            {badge}
          </span>
        )}
      </button>
    </div>
  );
}
